export enum DemoDeviceSerials {
  Vitocal222 = '7733747-device-serial',
  Vitocal252a = '7720533-device-serial',
  Vitocal252MPK = '7202739-device-serial',
  Vitodens200WMaintenance = '7570781-device-serial',
  Vitodens200W = '7722311-device-serial',
  Vitodens300 = '7690296-device-serial',
  Vitodens300W = '7946868-device-serial',
  Vitodens343F = '7570953-device-serial',
  Vitocal200 = '7733738-device-serial',
  Vitocal200Error = '7727496-device-serial',
  Vitocal200Offline = '7733737-device-serial',
  Vitocal250A = '7720485-device-serial',
  Vitovalor = '7725048-device-serial',
  VitovalorError = '7725237-device-serial',
  Vitocharge = '7745667-device-serial',
  VitochargeV2Lag = '7372062-vitocharge-serial',
  VitochargeVX3 = '7727518-device-serial',
  VitoairFS = '7892763-device-serial',
  ViAir300 = '7372763-ventilation-serial',
  ViAir300F = '7372760-ventilation-serial',
  Vitodens100opentherm = '7570694-device-serial',
  Vitoligno300C = '7202733-device-serial',
}
